import { render, staticRenderFns } from "./MainLedgerPrint.vue?vue&type=template&id=bb3bb9e2&scoped=true"
import script from "./MainLedgerPrint.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrint.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrint.vue?vue&type=style&index=0&id=bb3bb9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3bb9e2",
  null
  
)

export default component.exports